/* eslint-disable react/jsx-props-no-spreading */
import { Boundary, MessageDisplay, ImageLoader } from 'components/common';
import { useDocumentTitle, useScrollTop, useFileHandler } from 'hooks';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from 'firebase/firebase';
import { query, collection, orderBy } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import { displayActionMessage } from 'helpers/utils';
import ImageItem from '../components/ImageItem';

const Images = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const [isUploading, setUploading] = useState(false);

  const [images, isLoadingImages, errorImages] = useCollection(
    query(collection(firebase.db, 'images'), orderBy('position')),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  const { imageFile, isFileLoading, onFileChange } = useFileHandler({
    image: {}
  });

  const onSubmitImage = async () => {
    setUploading(true);
    if (imageFile.image.file) {
      await firebase
        .addHomeImage(imageFile.image.file, images.docs.length)
        .catch(() => displayActionMessage('errorMessage1', 'error'));
      imageFile.image = {};
    }
    setUploading(false);
  };

  return (
    <Boundary>
      <div className="product-admin-header">
        <h3 className="product-admin-header-title">
          {t('adminImagesMessage')}
        </h3>
      </div>
      <div className="product-admin-subheader">
        <span>{t('adminImagesParagraph')}</span>
      </div>
      <div className="product-admin-items">
        <div>
          <div className="grid grid-product grid-count-6">
            <div className="grid-col">
              <h5>{t('productTableImage')}</h5>
            </div>
            <div className="grid-col grid-col-onlydesktop">
              <h5>ID</h5>
            </div>
            <div className="grid-col grid-col-onlydesktop">
              <h5>{t('imageTablePosition')}</h5>
            </div>
          </div>
          {errorImages && <MessageDisplay message={errorImages} />}
          {images &&
            !isLoadingImages &&
            images.docs.map((image) => {
              return (
                <ImageItem
                  key={image.id}
                  id={image.id}
                  name={image.data().name}
                  src={image.data().src}
                  position={image.data().position}
                />
              );
            })}
        </div>
        <br />
        <br />
        <div>
          {!isFileLoading && (
            <label htmlFor="product-input-file">
              <input
                hidden
                id="product-input-file"
                onChange={(e) =>
                  onFileChange(e, { name: 'image', type: 'single' })
                }
                type="file"
              />
              {t('productFormImageButton')}
            </label>
          )}
          <div
            className="product-form-image-wrapper"
            style={{ maxWidth: '30rem' }}
          >
            {imageFile.image.url && (
              <ImageLoader
                alt=""
                className="product-form-image-preview"
                src={imageFile.image.url}
              />
            )}
          </div>
        </div>
        <br />
        <br />
        <button
          type="button"
          className="button w-100-mobile"
          disabled={isUploading}
          onClick={onSubmitImage}
        >
          {isUploading ? <LoadingOutlined /> : <CheckOutlined />}
          &nbsp;
          {isUploading ? t('loadingMessage') : t('buttonConfirm')}
        </button>
      </div>
    </Boundary>
  );
};

export default withRouter(Images);
